import { TLocale } from '@internal/utils/machine/i18n/Locale';

export const getSlugifyOptions = (locale: TLocale = 'en') => ({
    lower: true,
    locale,
    trim: true,
    strict: true,
});
